import React, { useRef, useEffect } from 'react';
import L from 'leaflet';
import { Marker } from 'react-leaflet';

function PointerPodcast({ children, podcast, markerSize, selected, coords }) {
  const ref = useRef(null);

  const size = podcast.size || [78, 47];

  const orientationPopup = () => {
    if (podcast.longitudePodcast <= 900) {
      return [0, size[1] + 300];
    }
    
    return [0, 0];
  };

  //////////////////// Création des markers personnalisés////////////////////////////////////
  const icon = L.icon({
    iconUrl: podcast.icon,
    iconAnchor: [(size[0] * markerSize) / 2, 0],
    // popupAnchor: [0, 0],
    popupAnchor: orientationPopup(),
    iconSize: [size[0] * markerSize, size[1] * markerSize],
  });

  useEffect(() => {
    if (selected) ref.current.openPopup();
    else ref.current.closePopup();
  }, [selected]);

  return (
    <Marker ref={ref} icon={icon} position={coords} riseOnHover={true}>
      {children}
    </Marker>
  );
}

export default PointerPodcast;
